import { Controller } from "react-hook-form";
import { FieldError } from "../../../../FieldError";
import "./style.css";
import { Button } from "primereact/button";
import syncArrowsImageSrc from "./sync-arrows.png";
import { FieldsForMappingDropdown } from "../../../../FieldsForMappingDropdown";
import { confirmPopup } from "primereact/confirmpopup";
import { useRef } from "react";

export const MappingItemForm = ({
  scopeStringId,
  formState,
  onSubmit,
  onRemove,
  toastRef,
  loading,
  mappingFieldsObj,
  bitrix24FieldsOptionsStateRef,
  optimaFieldsOptionsStateRef,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = formState;

  const formElementRef = useRef(null);

  return (
    <form
      ref={formElementRef}
      onSubmit={handleSubmit((fData) => onSubmit(fData))}
    >
      <div className="MappingItemForm_grid">
        <div className="form_input_container">
          <Controller
            name="bitrixField.nameId"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FieldsForMappingDropdown
                systemStringId="bitrix24"
                scopeStringId={scopeStringId}
                toastRef={toastRef}
                primeDropdownPropsObj={{
                  value: field?.value,
                  onChange: (e) => {
                    field.onChange(e.value);
                    formElementRef.current.requestSubmit();
                  },
                  ...(loading ? { disabled: true } : {}),
                }}
                initialValueOptionObj={
                  mappingFieldsObj?.isNew
                    ? undefined
                    : mappingFieldsObj.bitrixField
                }
                optionsObjStateRef={bitrix24FieldsOptionsStateRef}
              />
            )}
          />
          <FieldError fieldErr={errors?.bitrixField?.nameId} />
        </div>

        <div style={{ justifySelf: "center" }}>
          <img width="76px" src={syncArrowsImageSrc} />
        </div>

        <div className="form_input_container">
          <Controller
            name="optimaField.nameId"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FieldsForMappingDropdown
                systemStringId="optima"
                scopeStringId={scopeStringId}
                toastRef={toastRef}
                primeDropdownPropsObj={{
                  value: field?.value,
                  onChange: (e) => {
                    field.onChange(e.value);
                    formElementRef.current.requestSubmit();
                  },
                  ...(loading ? { disabled: true } : {}),
                }}
                initialValueOptionObj={
                  mappingFieldsObj?.isNew
                    ? undefined
                    : mappingFieldsObj.optimaField
                }
                optionsObjStateRef={optimaFieldsOptionsStateRef}
              />
            )}
          />
          <FieldError fieldErr={errors?.optimaField?.nameId} />
        </div>

        {mappingFieldsObj?.isNew ? (
          <></>
        ) : (
          <Button
            icon="pi pi-times"
            outlined
            severity="danger"
            type="button"
            onClick={(e) => {
              confirmPopup({
                target: e.currentTarget,
                message: "Czy na pewno chcesz usunąć synchronizację?",
                icon: "pi pi-exclamation-triangle",
                accept: onRemove,
              });
            }}
            {...(loading ? { disabled: true, text: true } : {})}
          />
        )}

        {loading ? (
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "1.4rem", color: "var(--beUpColorLight)" }}
          ></i>
        ) : (
          <></>
        )}
      </div>
    </form>
  );
};
